/**
 * Naive, pure JS implementation of core ui-router services
 *
 * @packageDocumentation
 */
export * from './interface';
export * from './q';
export * from './injector';
export * from './baseLocationService';
export * from './hashLocationService';
export * from './memoryLocationService';
export * from './pushStateLocationService';
export * from './memoryLocationConfig';
export * from './browserLocationConfig';
export * from './utils';
export * from './plugins';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/vanilla/index.js
// module id = 323
// module chunks = 0